import { GetCounties } from '../actions/auth';

export default (store) => {
    // data that is general, and could be used by all users who go through
    store.dispatch(GetCounties());
};
